<template>
  <market-card :title="$t('pages.login.user.download_app_title_post_overview')">
    <p class="text-muted">{{ $t('pages.login.user.app_text') }}</p>
    <app-store-badges />
    <p
      class="small text-muted mt-3 mb-0"
      v-html="$t('pages.login.user.download_app_help_text', { app_help_link: helpUrl })"
    ></p>
  </market-card>
</template>

<script>
  import AppStoreBadges from '@base/components/AppStoreBadges.vue'
  import MarketCard from '@base/components/market/MarketCard.vue'

  export default {
    name: 'MarketAppCard',

    components: {
      AppStoreBadges,
      MarketCard,
    },

    props: {
      helpUrl: {
        type: String,
        required: true,
      },
    },
  }
</script>

<style scoped>

</style>
